import { render, staticRenderFns } from "./BerthaDisclaimer.vue?vue&type=template&id=99557574"
import script from "./BerthaDisclaimer.vue?vue&type=script&lang=js"
export * from "./BerthaDisclaimer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports